import { render, staticRenderFns } from "./404block.vue?vue&type=template&id=7abd5f98&"
import script from "./404block.vue?vue&type=script&lang=js&"
export * from "./404block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports